<section fxLayout="row wrap" fxLayoutAlign="center center" class="bdrop">
  <mat-card fxFlex="800px" fxFlex.xs="100%">
    <mat-card-title style="color: white; background-color: var(--mk3red); text-align: center;">Update Make Safes of RefNo 
      {{this.refNo}} {{this.lastNameS}}</mat-card-title>
    <form [formGroup]="form" autocomplete="off" novalidate (ngSubmit)="updateClaim(form.value)" fxLayout="column wrap"
      fxLayoutAlign="center center" fxLayoutGap="10px">
      <mat-card-content>
        
        <div fxLayout="column" fxLayoutGap="10px" style="width: 100%; margin-top: 10px;">
          <div fxLayout="row" fxLayoutAlign="space-between center"  >
            <div fxFlex="62%" >
              <label style="font-size: large; font-weight: bold; padding-right: 5px;">Signed Waiver Received?</label>
            </div>
            <div fxFlex="38%" >
              <input type="checkbox" style="transform: scale(1.8); margin-bottom: 8px; margin-right: 20px;" 
              [checked]="isSignedWaiverReceived" 
              (change)="radioChange($event, 0)"> 
              <!--<mat-radio-group aria-label="Select an option" style="font-weight: bold;" (change)="radioChange($event, 3)" formControlName="isSignedWaiverReceivedOptions" [ngModel]="isSignedWaiverReceived" aria-label="Select an option"> 
                <mat-radio-button style="margin-right: 20px;" [value]=true>Yes</mat-radio-button>
                <mat-radio-button [value]=false>No</mat-radio-button>
              </mat-radio-group>
                 <input type="checkbox" (change)="onChangeRequired($event, 0)" autofocus formControlName="buildingMakeSafeRequired"  class="form-control" [ngClass]="{ 'is-invalid': form.controls.siteReserveMakeSafe.errors }"/>
                <mat-error *ngIf="hasError('siteReserveMakeSafe', 'pattern')" style="display: inline-block;">Invalid!</mat-error> -->
            </div>
          </div>
        </div>

        <div fxLayout="column" fxLayoutGap="20px" style="width: 100%; margin-top: 10px;">
          <div fxLayout="row" fxLayoutAlign="space-between center"  >
            <div fxFlex="62%" >
              <label style="font-size: large; font-weight: bold; padding-right: 5px;">Building Make Safe Required</label>
            </div>
            <div fxFlex="38%" >
              <input type="checkbox" style="transform: scale(1.8); margin-bottom: 8px; margin-right: 20px;" 
              [checked]="buildingMakeSafeRequired" 
              (change)="radioChange($event, 1)"> 
              <!--<mat-radio-group aria-label="Select an option" style="font-weight: bold;" (change)="radioChange($event, 1)" formControlName="buildingMakeSafeRequiredOptions" [ngModel]="buildingMakeSafeRequired" aria-label="Select an option"> 
                <mat-radio-button style="margin-right: 8px;" [value]=true>Required</mat-radio-button>
                <mat-radio-button [value]=false>Not Required</mat-radio-button>
              </mat-radio-group>
                 <input type="checkbox" (change)="onChangeRequired($event, 0)" autofocus formControlName="buildingMakeSafeRequired"  class="form-control" [ngClass]="{ 'is-invalid': form.controls.siteReserveMakeSafe.errors }"/>
                <mat-error *ngIf="hasError('siteReserveMakeSafe', 'pattern')" style="display: inline-block;">Invalid!</mat-error> -->
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" style="width: 100%;" *ngIf="buildingMakeSafeRequired">
          <div fxFlex="62%">
            <mat-label style="font-size: medium;">Building Make Safe Start Date</mat-label>
          </div>
          <div fxFlex="38%">
            <mat-form-field fxFlex="100%" >
              <input matInput [matDatepicker]="picker" style="font-size: medium;margin-bottom: 3px;" placeholder="Choose a date" formControlName="buildingMakeSafeStartDate" id="buildingMakeSafeStartDate" (click)="picker.open()">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <!-- <mat-error *ngIf="hasError('buildingMakeSafeStartDate', 'required')">Valid date is required</mat-error> -->
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" style="width: 100%;" *ngIf="buildingMakeSafeRequired">
          <div fxFlex="62%">
            <mat-label style="font-size: medium;">Building Make Safe Completed Date</mat-label>
          </div>
          <div fxFlex="38%">
            <mat-form-field fxFlex="100%" >
              <input matInput [matDatepicker]="picker" style="font-size: medium;margin-bottom: 3px;" placeholder="Choose a date" formControlName="buildingMakeSafeCompletedDate" id="buildingMakeSafeCompletedDate" (click)="picker.open()">
              <mat-datepicker-toggle matSuffix [for]="picker" style='height: 5em'></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <!-- <mat-error *ngIf="hasError('buildingMakeSafeCompletedDate', 'required')">Valid date is required</mat-error> -->
            </mat-form-field>
          </div>
        </div>
       
        <div fxLayout="column" fxLayoutGap="20px" style="width: 100%; margin-top: 20px;">
          <div fxLayout="row" fxLayoutAlign="space-between center"  >
            <div fxFlex="62%" >
              <label style="font-size: large; font-weight: bold; padding-right: 5px;">Restoration Make Safe Required</label>
            </div>
            <div fxFlex="38%" >
              <input type="checkbox" style="transform: scale(1.8); margin-bottom: 8px; margin-right: 20px;" 
              [checked]="restorationMakeSafeRequired" 
              (change)="radioChange($event, 2)"> 
              <!-- <mat-radio-group aria-label="Select an option" style="font-weight: bold;" (change)="radioChange($event, 2)" formControlName="restorationMakeSafeRequiredOptions" [ngModel]="restorationMakeSafeRequired" aria-label="Select an option"> 
                <mat-radio-button style="margin-right: 8px;" [value]=true>Required</mat-radio-button>
                <mat-radio-button [value]=false>Not Required</mat-radio-button>
              </mat-radio-group> -->
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" style="width: 100%;" *ngIf="restorationMakeSafeRequired">
          <div fxFlex="62%">
            <mat-label style="font-size: medium;">Restoration Make Safe Start Date</mat-label>
          </div>
          <div fxFlex="38%">
            <mat-form-field fxFlex="100%" >
              <input matInput [matDatepicker]="picker" style="font-size: medium;margin-bottom: 3px;" placeholder="Choose a date" formControlName="restorationMakeSafeStartDate" id="restorationMakeSafeStartDate" (click)="picker.open()">
              <mat-datepicker-toggle matSuffix [for]="picker" ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <!-- <mat-error *ngIf="hasError('restorationMakeSafeStartDate', 'required')">Valid date is required</mat-error> -->
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" style="width: 100%;" *ngIf="restorationMakeSafeRequired">
          <div fxFlex="62%">
            <mat-label style="font-size: medium;">Restoration Make Safe Completed Date</mat-label>
          </div>
          <div fxFlex="38%">
            <mat-form-field fxFlex="100%" >
              <input matInput [matDatepicker]="picker" style="font-size: medium;margin-bottom: 3px;" placeholder="Choose a date" formControlName="restorationMakeSafeCompletedDate" id="restorationMakeSafeCompletedDate" (click)="picker.open()">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <!-- <mat-error *ngIf="hasError('restorationMakeSafeCompletedDate', 'required')">Valid date is required</mat-error> -->
            </mat-form-field>
          </div>
        </div>

      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button class="btn btn-danger" style="margin-right: 20px ;" [disabled]="!form.valid || !isChanged">Update Make Safes</button>
        <button type="button" mat-raised-button class="btn btn-danger" (click)="onCancel()">Cancel</button>
      </mat-card-actions>
    </form>
  </mat-card>
</section>
